import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isOpen: false,
  item: null,
  type: null,
  commentary: '',
  selectedFriends: [],
  sentFriends: [],
  isPosting: false,
};

const shareModalSlice = createSlice({
  name: 'shareModal',
  initialState,
  reducers: {
    openShareModal: (state, action) => {
      const validTypes = ['post', 'solution', 'comment', 'reply'];

      if (!action.payload) {
        state.isOpen = true;
        state.item = null;
        state.type = 'post';
        state.commentary = '';
        state.selectedFriends = [];
        state.sentFriends = [];
        state.isPosting = false;
        return;
      }

      const { item, type } = action.payload;

      if (!item || !item.id) {
        console.warn('[shareModal] openShareModal called without valid item.id');
        return;
      }

      state.isOpen = true;
      state.item = item;
      state.type = validTypes.includes(type) ? type : 'post';
      state.commentary = '';
      state.selectedFriends = [];
      state.sentFriends = [];
      state.isPosting = false;
    },
    closeShareModal: (state) => {
      state.isOpen = false;
      state.item = null;
      state.type = null;
      state.commentary = '';
      state.selectedFriends = [];
      state.sentFriends = [];
      state.isPosting = false;
    },
    updateShareCommentary: (state, action) => {
      state.commentary = action.payload || '';
    },
    toggleFriendSelection: (state, action) => {
      const friendId = action.payload;
      const index = state.selectedFriends.indexOf(friendId);
      if (index > -1) {
        state.selectedFriends.splice(index, 1);
      } else {
        state.selectedFriends.push(friendId);
      }
    },
    clearFriendSelection: (state) => {
      state.selectedFriends = [];
    },
    setShareModalPosting: (state, action) => {
      state.isPosting = action.payload;
    },
    markFriendSent: (state, action) => {
      const friendId = action.payload;
      if (!state.sentFriends.includes(friendId)) {
        state.sentFriends.push(friendId);
      }
    },
    clearSentFriends: (state) => {
      state.sentFriends = [];
    },
  },
});

export const {
  openShareModal,
  closeShareModal,
  updateShareCommentary,
  toggleFriendSelection,
  clearFriendSelection,
  setShareModalPosting,
  markFriendSent,
  clearSentFriends,
} = shareModalSlice.actions;

export default shareModalSlice.reducer;
